import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';

/**
 * "← Volver a Sellers › Nombre" above a detail page, from `SellerDetail`.
 *
 * A link rather than a button, so the listing can also be opened in a new tab.
 *
 * @param {object} props
 * @param {string} props.backLabel - "Volver a Integraciones".
 * @param {string} props.to - The listing.
 * @param {React.ReactNode} props.current - What is being looked at.
 * @param {string} [props.testId='detail-breadcrumb']
 */
export const DetailBreadcrumb = ({ backLabel, to, current, testId = 'detail-breadcrumb' }) => (
  <nav
    aria-label="Ruta de navegación"
    data-testid={testId}
    className="flex items-center gap-2 text-sm text-text-secondary min-w-0"
  >
    <Link
      to={to}
      className="hover:text-ninja-dark dark:hover:text-white transition-colors flex items-center gap-1 flex-shrink-0"
    >
      <ArrowLeft size={14} /> {backLabel}
    </Link>
    <ChevronRight size={14} className="text-border flex-shrink-0" />
    <span className="font-semibold text-ninja-dark dark:text-white truncate">{current}</span>
  </nav>
);
